import { isFinanceProject } from 'config';
import { OnboardingRegistrationAddress } from 'modules/onboarding/common/components/OnboardingRegistrationAddress';

import { useRegistrationAddress } from '../hooks';
import { PageComponentProps } from '../types';

export const RegistrationAddressStep = ({ canGoBack }: PageComponentProps) => {
  const {
    countries,
    countriesLoading,
    initialValues,
    files,
    submitLoading,
    submitDisabled,
    onAddFiles,
    onRemoveFile,
    onSubmit,
    goToBack,
  } = useRegistrationAddress();

  return (
    <OnboardingRegistrationAddress
      enabledFiles
      canGoBack={canGoBack}
      countries={countries}
      countriesLoading={countriesLoading}
      enabledRegistrationAddress={isFinanceProject()}
      files={files}
      initialValues={initialValues}
      submitDisabled={submitDisabled}
      submitLoading={submitLoading}
      onAddFiles={onAddFiles}
      onGoBack={goToBack}
      onRemoveFile={onRemoveFile}
      onSubmit={onSubmit}
    />
  );
};
